import React from 'react'
import Typography from '@mui/material/Typography'
import { grey } from '../../../../colors'

interface LeadTextProp {
  children: React.ReactNode
  disabled?: boolean
  onClick?: (e: React.MouseEvent) => void
}

const LeadText: React.FC<LeadTextProp> = ({ children, disabled = false, onClick, ...props }) => {
  return (
    <Typography component={'span'} fontWeight='500' fontSize='14px' color={grey[disabled ? 350 : 250]} onClick={onClick}>
      {children}
    </Typography >
  )
}

export default LeadText
